import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

const usePasswordReset = () => {
  return useMutation({
    mutationFn: async (
      email: string
    ): Promise<unknown | null> => {
      if (!email) return null;
      
      const URL = `${import.meta.env.VITE_API_RESET_PASSWORD_URL}?email=${email}`;

      const { data } = await axiosClient.post<unknown>(URL);

      return data;
    },
  });
};

export default usePasswordReset;
